<template>
	<div class="table-container">
		<template v-if="surveys.length >0">
			<div class="row" style="margin-top: 1%;">
				<div class="col-xl-3 col-lg-4">
					<b-pagination
					v-model="currentPage"
					:total-rows="rows"
					:per-page="perPage"
					aria-controls="surveyList"
					></b-pagination>
				</div>
			</div>
			<b-table ref="surveysTable"
			id="surveyList"
			:per-page="perPage"
			:current-page="currentPage"
			:fields="headers" 
			:items="surveys"
			class="scrollable-table-container" 
			responsive="sm">
				<template #cell(name)="data">
					{{ data.item.name }}
				</template>
				<template #cell(surname)="data">
					{{ data.item.surname }}
				</template>
				<template #cell(city)="data">
					{{ data.item.city }}
				</template>
				<template #cell(email)="data">
					{{ data.item.email }}
				</template>
				<template #cell(phone)="data">
					{{ data.item.phone }}
				</template>
				<template #cell(field)="data">
					{{ data.item.field }}
				</template>
				<template #cell(location)="data">
					{{ data.item.location }}
				</template>
				<template #cell(enterprise)="data">
					{{ data.item.enterprise }}
				</template>
				<template #cell(avg_score)="data">
					{{ data.item.avg_score }}
				</template>
				<template #cell(created_at)="data">
					{{ data.item.created_at | formatDate}}
				</template>
				<template #cell(options)="data">
					<button v-if="!data.detailsShowing" v-b-tooltip.hover title="Show survey details" class="btn" @click="data.toggleDetails">
						<font-awesome-icon icon="eye" />
					</button>
					<button v-else v-b-tooltip.hover title="Hide survey details" class="btn" @click="data.toggleDetails">
						<font-awesome-icon icon="eye-slash" />
					</button>
				</template>
				<template #row-details="data">
					<div class="col-sm-12 toggle-table">
						<h3>Fijación de Población</h3>
				        <table>
				        	<thead>
				        		<th>Pregunta</th>
				        		<th>Opción 1</th>
				        		<th>Opción 2</th>
				        		<th>Opción 3</th>
				        		<th>Opción 4</th>
				        		<th>Justificación</th>
				        	</thead>
				        	<tbody>
				        		<tr>
							    	<td>1.- Empleo local. Elige la respuesta que mejor describa tu actividad:</td>
						            <td :style="data.item.question_1_selection == 1 ? { backgroundColor: '#ce93d875' } : {}">Emplea mano de obra local (de la misma población o poblaciones limítrofes) Y contribuye a la creación de empleo local de manera indirecta.</td>
						            <td :style="data.item.question_1_selection == 2 ? { backgroundColor: '#ce93d875' } : {}">Emplea mano de obra local (de la misma población o poblaciones limítrofes) O contribuye a la creación de empleo local de manera indirecta.</td>
						            <td :style="data.item.question_1_selection == 3 ? { backgroundColor: '#ce93d875' } : {}">De forma ocasional emplea mano de obra local (de la misma población o poblaciones limítrofes) o crea empleo indirecto.</td>
						            <td :style="data.item.question_1_selection == 4 ? { backgroundColor: '#ce93d875' } : {}">No contribuye a la creación de mano de obra local (de la misma población o poblaciones limítrofes).</td>
						            <td>{{data.item.question_1_description}}</td>
						        </tr>
					            <tr>
							    	<td>2.- Economía Familiar. Elige la respuesta que mejor describa tu actividad:</td>
						            <td :style="data.item.question_2_selection == 1 ? { backgroundColor: '#ce93d875' } : {}">Se trata de una empresa familiar (PYME, gestionada por una familia con la implicación de varias generaciones) y colabora con PYMEs familiares locales de alguna manera.</td>
						            <td :style="data.item.question_2_selection == 2 ? { backgroundColor: '#ce93d875' } : {}">Se trata de una empresa familiar (PYME, gestionada por una familia con la implicación de varias generaciones).</td>
						            <td :style="data.item.question_2_selection == 3 ? { backgroundColor: '#ce93d875' } : {}">No es una empresa familiar pero está gestionada de manera familiar y local.</td>
						            <td :style="data.item.question_2_selection == 4 ? { backgroundColor: '#ce93d875' } : {}">La empresa no cuenta con raigambre local ni se gestiona de manera familiar o local.</td>
						            <td>{{data.item.question_2_description}}</td>
						        </tr>
							    <tr>
							    	<td>3.- Masculinización. Elige la respuesta que mejor describa tu actividad:</td>
						            <td :style="data.item.question_3_selection == 1 ? { backgroundColor: '#ce93d875' } : {}">Contrata o implica a mano de obra femenina al menos en la misma proporción que masculina.</td>
						            <td :style="data.item.question_3_selection == 2 ? { backgroundColor: '#ce93d875' } : {}">Contrata o implica a mano de obra femenina pero no en la misma proporción que masculina.</td>
						            <td :style="data.item.question_3_selection == 3 ? { backgroundColor: '#ce93d875' } : {}">Cuenta con mano de obra femenina de manera ocasional.</td>
						            <td :style="data.item.question_3_selection == 4 ? { backgroundColor: '#ce93d875' } : {}">No cuenta con mano de obra femenina.</td>
						            <td>{{data.item.question_3_description}}</td>
						        </tr>
					            <tr>
							    	<td>4.- Envejecimiento. Elige la respuesta que mejor describa tu actividad:</td>
						            <td :style="data.item.question_4_selection == 1 ? { backgroundColor: '#ce93d875' } : {}">Emplea principalmente mano de obra joven (por debajo de la edad promedio en las zonas rurales o en la zona).</td>
						            <td :style="data.item.question_4_selection == 2 ? { backgroundColor: '#ce93d875' } : {}">Emplea alguna mano de obra joven o toma alguna medida para fomentarlo (por debajo de la edad promedio en las zonas rurales o en la zona).</td>
						            <td :style="data.item.question_4_selection == 3 ? { backgroundColor: '#ce93d875' } : {}">El empleo principal está en torno a la edad promedio de la zona o de las zonas rurales.</td>
						            <td :style="data.item.question_4_selection == 4 ? { backgroundColor: '#ce93d875' } : {}">No fomenta el empleo joven.</td>
						            <td>{{data.item.question_4_description}}</td>
						        </tr>
					            <tr>
							    	<td>5.- Servicios. Elige la respuesta que mejor describa tu actividad:</td>
						            <td :style="data.item.question_5_selection == 1 ? { backgroundColor: '#ce93d875' } : {}">La actividad está implicada con las actividades sociales y los servicios de su zona o las fomenta de alguna manera.</td>
						            <td :style="data.item.question_5_selection == 2 ? { backgroundColor: '#ce93d875' } : {}">La actividad implica al sector servicios o lo promueve de alguna manera.</td>
						            <td :style="data.item.question_5_selection == 3 ? { backgroundColor: '#ce93d875' } : {}">La actividad no está implicada en la actividad social ni en el sector servicios pero su presencia puede contribuir a mantenerlos.</td>
						            <td :style="data.item.question_5_selection == 4 ? { backgroundColor: '#ce93d875' } : {}">No fomenta actividad social en la zona, no implica al sector servicios ni contribuye a mantenerlo.</td>
						            <td>{{data.item.question_5_description}}</td>
						        </tr>
				        	</tbody>
				        </table>
			        </div>
			        <hr>
			        <div class="col-sm-12 toggle-table">
						<h3>Tejido Social</h3>
				        <table>
				        	<thead>
				        		<th>Pregunta</th>
				        		<th>Opción 1</th>
				        		<th>Opción 2</th>
				        		<th>Opción 3</th>
				        		<th>Opción 4</th>
				        		<th>Justificación</th>
				        	</thead>
				        	<tbody>
							    <tr>
							        <td>6.- Acción social. Elige la respuesta que mejor describa tu actividad:</td>
						            <td :style="data.item.question_6_selection == 1 ? { backgroundColor: '#ce93d875' } : {}">La actividad está implicada con el tejido social Y fomenta actividades que revierten en la zona.</td>
						            <td :style="data.item.question_6_selection == 2 ? { backgroundColor: '#ce93d875' } : {}">La actividad está implicada con el tejido social O fomenta actividades que revierten en la zona.</td>
						            <td :style="data.item.question_6_selection == 3 ? { backgroundColor: '#ce93d875' } : {}">La presencia de la actividad contribuye al tejido social.</td>
						            <td :style="data.item.question_6_selection == 4 ? { backgroundColor: '#ce93d875' } : {}">La presencia de la actividad no contribuye al tejido social ni revierte de ninguna manera en la población de su entorno.</td>
							        <td>{{data.item.question_6_description}}</td>
							    </tr>
							    <tr>
							        <td>7.- Arraigo. Elige la respuesta que mejor describa tu actividad:</td>
						            <td :style="data.item.question_7_selection == 1 ? { backgroundColor: '#ce93d875' } : {}">La actividad cuenta con una larga tradición en la zona Y está implicada en actividades locales y/o tradicionales.</td>
						            <td :style="data.item.question_7_selection == 2 ? { backgroundColor: '#ce93d875' } : {}">La actividad cuenta con una larga tradición en la zona O está implicada en actividades locales y/o tradicionales.</td>
						            <td :style="data.item.question_7_selection == 3 ? { backgroundColor: '#ce93d875' } : {}">Aunque la actividad no cuenta con una tradición, cuenta con arraigo personal o se ha integrado de manera efectiva en la población.</td>
						            <td :style="data.item.question_7_selection == 4 ? { backgroundColor: '#ce93d875' } : {}">La actividad no cuenta con arraigo ni se ha integrado en la zona.</td>
							        <td>{{data.item.question_7_description}}</td>
							    </tr>
							    <tr>
							        <td>8.- Proveedores locales. Elige la respuesta que mejor describa tu actividad:</td>
						            <td :style="data.item.question_8_selection == 1 ? { backgroundColor: '#ce93d875' } : {}">La actividad usa únicamente proveedores locales y pone en valor esos productos.</td>
						            <td :style="data.item.question_8_selection == 2 ? { backgroundColor: '#ce93d875' } : {}">La actividad no precisa principalmente de producto local pero lo usa siempre que puede o contribuye a poner en valor los productos locales.</td>
						            <td :style="data.item.question_8_selection == 3 ? { backgroundColor: '#ce93d875' } : {}">La actividad usa en cierta medida proveedores locales.</td>
						            <td :style="data.item.question_8_selection == 4 ? { backgroundColor: '#ce93d875' } : {}">El tipo de actividad no implica el uso de producto local o implicándolo no usa proveedores locales.</td>
							        <td>{{data.item.question_8_description}}</td>
							    </tr>
							    <tr>
							        <td>9.- Circuitos de venta. Elige la respuesta que mejor describa tu actividad:</td>
						            <td :style="data.item.question_9_selection == 1 ? { backgroundColor: '#ce93d875' } : {}">La actividad cuenta con circuitos de venta locales pero también exporta producto fuera de la zona atrayendo beneficios.</td>
						            <td :style="data.item.question_9_selection == 2 ? { backgroundColor: '#ce93d875' } : {}">La actividad cuenta con circuitos de distribución exclusivamente locales.</td>
						            <td :style="data.item.question_9_selection == 3 ? { backgroundColor: '#ce93d875' } : {}">La actividad no cuenta con circuitos de venta claros o no supone una activación económica de la zona.</td>
						            <td :style="data.item.question_9_selection == 4 ? { backgroundColor: '#ce93d875' } : {}">-</td>
							        <td>{{data.item.question_9_description}}</td>
							    </tr>
							    <tr>
							        <td>10.- Activación económica. Elige la respuesta que mejor describa tu actividad:</td>
						            <td :style="data.item.question_10_selection == 1 ? { backgroundColor: '#ce93d875' } : {}">La actividad implica el fortalecimiento y promoción de nichos económicos tradicionales o la aparición de nuevos nichos económicos.</td>
						            <td :style="data.item.question_10_selection == 2 ? { backgroundColor: '#ce93d875' } : {}">Se trata de una actividad tradicional o similar a otras presentes en la zona.</td>
						            <td :style="data.item.question_10_selection == 3 ? { backgroundColor: '#ce93d875' } : {}">La actividad no contribuye a la activación económica de la zona.</td>
						            <td :style="data.item.question_10_selection == 4 ? { backgroundColor: '#ce93d875' } : {}">-</td>
							        <td>{{data.item.question_10_description}}</td>
							    </tr>
				        	</tbody>
				        </table>
					</div>
					<hr>
					<div class="col-sm-12 toggle-table">
						<h3>Naturaleza</h3>
				        <table>
				        	<thead>
				        		<th>Pregunta</th>
				        		<th>Opción 1</th>
				        		<th>Opción 2</th>
				        		<th>Opción 3</th>
				        		<th>Opción 4</th>
				        		<th>Justificación</th>
				        	</thead>
				        	<tbody>
							    <tr>
							        <td>11.- Biodiversidad. Elige la respuesta que mejor describa tu actividad:</td>
						            <td :style="data.item.question_11_selection == 1 ? { backgroundColor: '#ce93d875' } : {}">Introduce actuaciones especialmente diseñadas para mejorar la condición de especies de interés para la conservación.</td>
						            <td :style="data.item.question_11_selection == 2 ? { backgroundColor: '#ce93d875' } : {}">Sus prácticas son respetuosas con la conservación de especies de mayor interés en ese territorio.</td>
						            <td :style="data.item.question_11_selection == 3 ? { backgroundColor: '#ce93d875' } : {}">Sus prácticas son respetuosas con la conservación de especies de interés en ese territorio.</td>
						            <td :style="data.item.question_11_selection == 4 ? { backgroundColor: '#ce93d875' } : {}">No se tiene en cuenta la biodiversidad en la planificación de actividades.</td>
							        <td>{{data.item.question_11_description}}</td>
							    </tr>
							    <tr>
							        <td>12.- Espacios naturales protegidos. Elige la respuesta que mejor describa tu actividad:</td>
						            <td :style="data.item.question_12_selection == 1 ? { backgroundColor: '#ce93d875' } : {}">Si la actividad se desarrolla en algún espacio natural protegido e introduce actuaciones que favorecen el estado de conservación de ese espacio.</td>
						            <td :style="data.item.question_12_selection == 2 ? { backgroundColor: '#ce93d875' } : {}">Si la actividad se desarrolla en algún espacio natural protegido.</td>
						            <td :style="data.item.question_12_selection == 3 ? { backgroundColor: '#ce93d875' } : {}">La actividad no se desarrolla dentro de un espacio natural protegido.</td>
						            <td :style="data.item.question_12_selection == 4 ? { backgroundColor: '#ce93d875' } : {}">-</td>
							        <td>{{data.item.question_12_description}}</td>
							    </tr>
							    <tr>
							        <td>13.- Hábitats. Elige la respuesta que mejor describa tu actividad:</td>
						            <td :style="data.item.question_13_selection == 1 ? { backgroundColor: '#ce93d875' } : {}">Introduce actuaciones especialmente diseñadas para mejorar la condición de hábitats de interés y prioritarios para la conservación.</td>
						            <td :style="data.item.question_13_selection == 2 ? { backgroundColor: '#ce93d875' } : {}">Sus prácticas son respetuosas con la conservación de hábitats prioritarios en ese territorio.</td>
						            <td :style="data.item.question_13_selection == 3 ? { backgroundColor: '#ce93d875' } : {}">Sus prácticas son respetuosas con la conservación de hábitats de interés en ese territorio.</td>
						            <td :style="data.item.question_13_selection == 4 ? { backgroundColor: '#ce93d875' } : {}">La zona no presenta hábitats de interés para la conservación, o no se tienen en cuenta en la planificación de actividades.</td>
							        <td>{{data.item.question_13_description}}</td>
							    </tr>
							    <tr>
							        <td>14.- Extensión. Elige la respuesta que mejor describa tu actividad:</td>
						            <td :style="data.item.question_14_selection == 1 ? { backgroundColor: '#ce93d875' } : {}">Las prácticas implementadas favorecen la extensión de ecosistemas que suponen un incremento importante de servicios ecosistémicos suministrados (uno tipo I y dos tipo II o cuatro tipo II).</td>
						            <td :style="data.item.question_14_selection == 2 ? { backgroundColor: '#ce93d875' } : {}">Las prácticas implementadas favorecen la extensión de ecosistemas que suponen un incremento de servicios ecosistémicos suministrados (uno tipo I o dos tipo II).</td>
						            <td :style="data.item.question_14_selection == 3 ? { backgroundColor: '#ce93d875' } : {}">Las prácticas implementadas favorecen algo la extensión de ecosistemas que suponen un incremento de servicios ecosistémicos (uno tipo II).</td>
						            <td :style="data.item.question_14_selection == 4 ? { backgroundColor: '#ce93d875' } : {}">Las prácticas implementadas no favorecen la extensión de ecosistemas que suponen un incremento de servicios ecosistémicos.</td>
							        <td>{{data.item.question_14_description}}</td>
							    </tr>
							    <tr>
							        <td>15.- Condición. Elige la respuesta que mejor describa tu actividad:</td>
						            <td :style="data.item.question_15_selection == 1 ? { backgroundColor: '#ce93d875' } : {}">Las prácticas implementadas favorecen la condición de ecosistemas que suponen un incremento importante de servicios ecosistémicos suministrados (uno tipo I y dos tipo II o cuatro tipo II).</td>
						            <td :style="data.item.question_15_selection == 2 ? { backgroundColor: '#ce93d875' } : {}">Las prácticas implementadas favorecen la condición de ecosistemas que suponen un incremento de servicios ecosistémicos suministrados (uno tipo I o dos tipo II).</td>
						            <td :style="data.item.question_15_selection == 3 ? { backgroundColor: '#ce93d875' } : {}">Las prácticas implementadas favorecen algo la condición de ecosistemas que suponen un incremento de servicios ecosistémicos (uno tipo II).</td>
						            <td :style="data.item.question_15_selection == 4 ? { backgroundColor: '#ce93d875' } : {}">Las prácticas implementadas no favorecen la condición de ecosistemas que suponen un incremento de servicios ecosistémicos.</td>
							        <td>{{data.item.question_15_description}}</td>
							    </tr>
							    <tr>
							        <td>16.- Conocimiento tradicional. Elige la respuesta que mejor describa tu actividad:</td>
						            <td :style="data.item.question_16_selection == 1 ? { backgroundColor: '#ce93d875' } : {}">La actividad se basa en usos o técnicas tradicionales que contribuyen a garantizar la preservación de la herencia ecológica recibida.</td>
						            <td :style="data.item.question_16_selection == 2 ? { backgroundColor: '#ce93d875' } : {}">Durante la actividad se emplean usos o técnicas tradicionales que contribuyen a garantizar la preservación de la herencia ecológica recibida.</td>
						            <td :style="data.item.question_16_selection == 3 ? { backgroundColor: '#ce93d875' } : {}">La actividad emplea ligeramente usos o técnicas tradicionales que contribuyen a garantizar la preservación de la herencia ecológica.</td>
						            <td :style="data.item.question_16_selection == 4 ? { backgroundColor: '#ce93d875' } : {}">La actividad no emplea usos o técnicas tradicionales que contribuyen a garantizar la preservación de la herencia ecológica recibida.</td>
							        <td>{{data.item.question_16_description}}</td>
							    </tr>
							    <tr>
							        <td>17.- Paisaje cultural // razas y variedades autóctonas. Elige la respuesta que mejor describa tu actividad:</td>
						            <td :style="data.item.question_17_selection == 1 ? { backgroundColor: '#ce93d875' } : {}">La actividad contribuye decididamente al mantenimiento de paisajes culturales o razas y variedades autóctonas.</td>
						            <td :style="data.item.question_17_selection == 2 ? { backgroundColor: '#ce93d875' } : {}">La actividad contribuye moderadamente al mantenimiento de paisajes culturales o razas y variedades autóctonas.</td>
						            <td :style="data.item.question_17_selection == 3 ? { backgroundColor: '#ce93d875' } : {}">La actividad contribuye ligeramente al mantenimiento de paisajes culturales o razas y variedades autóctonas.</td>
						            <td :style="data.item.question_17_selection == 4 ? { backgroundColor: '#ce93d875' } : {}">La actividad no contribuye al mantenimiento de paisajes culturales o razas y variedades autóctonas.</td>
							        <td>{{data.item.question_17_description}}</td>
							    </tr>
				        	</tbody>
				        </table>
					</div>
			    </template>
			</b-table>
		</template>
		<template v-else>
			<h3 class="no-results-msg"><font-awesome-icon icon="times-circle" class="black-color"/> No surveys found.</h3>
		</template>
	</div>
</template>

<script>
	import SurveyService from '@/services/survey.service';

	export default {
		name: 'SurveyListComponent',
		data() {
	      return {
	      	headers: [
	          { key: 'name', sortable: true, label: 'Nombre' }, { key: 'surname', sortable: true, label: 'Apellidos' }, { key: 'city', sortable: true, label: 'Localidad' }, { key: 'email', sortable: true, label: 'Email' }, { key: 'phone', sortable: true, label: 'Teléfono' }, { key: 'field', sortable: true, label: 'Sector' }, { key: 'location', sortable: true, label: 'Localización' }, { key: 'enterprise', sortable: true, label: 'Empresa/Proyecto' }, { key: 'avg_score', sortable: true, label: 'Puntuación' }, { key: 'created_at', sortable: true, label: 'Fecha' }, { key: 'options', label: 'Opciones' }
	        ],
	        message: "",
	        perPage: 10,
        	currentPage: 1
	      }
	    },
		props: {
		    surveys: Array
		},
	    computed: {
	      rows() {
	        return this.surveys.length
	      }
	    },
		mounted() {
		},
	  	methods: {
	    }
	};

</script>
<style scoped>
</style>